require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shyamala-gopinath.json") })
        }
      }, "path---shyamala-gopinath");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shyamala-gopinath!./.cache/json/shyamala-gopinath.json
// module id = 649
// module chunks = 231608221292675